import { Component, AfterViewInit } from '@angular/core';
import { PlatformLocation } from '@angular/common';
import { Event, Router, ActivatedRoute, NavigationStart, NavigationEnd, RouterEvent } from '@angular/router';
import { AuthenticationService } from './authentication/authentication.service';
import { GlobalService } from './global.service';
import { HttpService } from './http.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements AfterViewInit {
  title = 'aavin-portal';

  currentUrl: string = '';
  showLoadingIndicatior = true;
  first_name = ''
  user_type = ''
  user_position = ''
  user_image = 'no-image'

  headers = [];
  pages = [];
  toggle_header_ids = [];

  selected_header_id: number = null;
  selected_page_id: number = null;

  constructor(private http: HttpService,private router: Router, private activa: ActivatedRoute, location: PlatformLocation, private authService: AuthenticationService, public global: GlobalService) {
    console.log = function () { };

    // this.http.getEmployeeUserType().subscribe((data) => {
    //   console.log(data);
    //   if (data !== 2) {
    //     console.log = function () { };
    //   }
    // }, (error) => {
    //   console.error(error);
    // });

    this.authService.menu_header.subscribe((data) => {
      console.log(data);
      this.pages = data['page'];
      this.headers = data['header'];
    });
    this.headers = JSON.parse(localStorage.getItem('headers'));
    this.pages = JSON.parse(localStorage.getItem('pages'));

    this.first_name = localStorage.getItem('first_name');
    this.user_type = localStorage.getItem('user_type');
    this.user_image = localStorage.getItem('user_image');
    this.user_position = localStorage.getItem('user_position');
    this.global.set_active_user = this.first_name;
    this.global.set_active_user_type = this.user_type;
    this.global.set_active_image = this.user_image;
    this.global.set_active_user_position = this.user_position;
    this.router.events.subscribe((routerEvent: Event) => {

      if (routerEvent instanceof NavigationStart) {
        this.showLoadingIndicatior = true;
        location.onPopState(() => {
          window.location.reload();
        });
        this.currentUrl = routerEvent.url.substring(routerEvent.url.lastIndexOf('/') + 1);
      }
      if (this.currentUrl.trim() === "signin" || this.currentUrl.trim() === "login" || this.currentUrl.trim() === "signup" || this.currentUrl.trim() === "forgot-password" || this.currentUrl.trim() === "locked" || this.currentUrl.trim() === "page404" || this.currentUrl.trim() === "page500") {
        document.getElementById("main-component").style["display"] = "none";
      } else {
        document.getElementById('main-component').style.removeProperty("display");
      }
      if (routerEvent instanceof NavigationEnd) {
        this.showLoadingIndicatior = false;
      }
      window.scrollTo(0, 0);
    });
  }

  logOut() {
    if (confirm('Are you sure to logout ?')) {
      this.authService.logout();
      this.router.navigateByUrl('login');
      this.global.set_active_image = 'no-image';
    }
  }

  navPage(url, page_id, display_name) {
    this.global.set_active_url = url;
    this.global.set_active_url_display_name = display_name;
    this.selected_page_id = page_id;
    this.router.navigateByUrl('temp/refresh');
  }

  ngAfterViewInit() {
    const token = localStorage.getItem('TOKEN_KEY');
    if (token !== null) {
      // this.router.navigateByUrl('dashboard');
    } else {
      this.router.navigateByUrl('login');
    }
  }

  routePageTo(page, page_id) {
    if (page !== null) {
      this.selected_page_id = page_id;
      this.router.navigateByUrl(page);
    }
  }

  isShowPage(header_id) {
    if (this.toggle_header_ids.indexOf(header_id) > -1) {
      return 'block';
    }
  }

  toggleHeader(header_id) {
    if (this.toggle_header_ids.indexOf(header_id) < 0) {
      this.toggle_header_ids.push(header_id);
      this.selected_header_id = header_id;
    } else {
      const index = this.toggle_header_ids.indexOf(header_id);
      this.toggle_header_ids.splice(index, 1);
    }
    console.log(this.toggle_header_ids);
  }
}
